import Card from "PFComponents/card/card";
import ConfirmModal from "PFComponents/confirm/confirm_modal";
import DataTable from "PFComponents/data_table/data_table";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import { Template } from "../types";
import css from "./styles.module.scss";
import { ConfirmModalConfig, ToggleAction, ToggleIdentifier } from "./types";
import useColumns from "./useColumns";

interface Props {
  tableRows: Template[];
  onToggleClick: (action: ToggleAction) => void;
  changedToggle: ToggleIdentifier | null;
}

const initialModalState: ConfirmModalConfig = {
  isDisplayed: false,
  rowId: null
};

const InterestQuestionsPage = ({ tableRows, changedToggle, onToggleClick }: Props): JSX.Element => {
  const { t } = useTranslation("interestQuestions");
  const history = useHistory();
  const [confirmModal, setConfirmModal] = useState<ConfirmModalConfig>(initialModalState);

  const goToEditPage = (rowId: number) => {
    history.push(`/admin/interest_questions/${rowId}/edit`);
  };

  const openConfirmModal = (rowId: number) => {
    setConfirmModal({
      isDisplayed: true,
      rowId
    });
  };

  const columns = useColumns(changedToggle, openConfirmModal, goToEditPage, onToggleClick);

  return (
    <div className={css.root}>
      <h2 className={css.title}>{t("templates.title")}</h2>
      <h5>{t("templates.description")}</h5>
      <Card noPadding>
        <DataTable data={tableRows} columns={columns} withSpacing rounded />
      </Card>
      {confirmModal.isDisplayed && (
        <ConfirmModal
          handleOK={() => {
            if (confirmModal.rowId) {
              goToEditPage(confirmModal.rowId);
            }
            setConfirmModal(initialModalState);
          }}
          handleClose={() => {
            setConfirmModal(initialModalState);
          }}
          labelOK={t("templates.editQuestions")}
          showCancelIcon={false}
        >
          {t("templates.editQuestionsToProceed")}
        </ConfirmModal>
      )}
    </div>
  );
};

export default InterestQuestionsPage;
